<template>
  <tr>
    <td>
      <p
        @click="showPreviewList(reviewLists._id)"
        style="color: #036AC9; cursor: pointer;"
      >
        {{ reviewLists.title }}
      </p>
    </td>
    <!-- <td><router-link :to="`test`">{{ reviewList.title }}</router-link></td> -->
    <td>
      <p
        v-for="client_users in reviewLists.client_users"
        :key="client_users._id"
      >
        {{ client_users.full_name }}
      </p>
    </td>
    <td style="text-align: center !important;">
      <button
        class="btn-plain btn-heart template-Btn"
        @click="editReviewList()"
      >
        <img
          :src="require('@/assets/images/pencil.svg')"
          alt="編集"
          class="icon-label"
        />
      </button>
      <button
        class="btn-plain btn-heart template-Btn ms-2"
        v-b-modal="reviewLists._id"
        @click="openDeletePopup()"
      >
        <img
          :src="require('@/assets/images/dustbin.svg')"
          alt="削除"
          class="icon-label"
        />
      </button>

    </td>
    <CreateReviewList
      v-if="showCreateReviewListPopup"
      :isEditing="true"
      :reviewLists="reviewLists"
      @hideModal="hideModal"
    />
    <ConfirmationModal
      ref="confirmationModal"
      :message="'このリストを削除しますか？'"
      @cancel="closeDeleteModal"
      @confirm="destroy"
    />

    <!-- <ApplicantPreview
      v-if="showReviewListPopup"
      ref="previewListModal"
      :review_list_id="reviewLists._id"
      @hidePreviewListModal="hidePreviewListModal"
    /> -->
  </tr>
</template>

<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations, mapActions } from 'vuex';
import CreateReviewList from './CreateReviewList.vue';
import ConfirmationModal from '../../utils/ConfirmationModal.vue';
// import ApplicantPreview from '../applicantsPreview/ApplicantPreview.vue';

export default {
  name: 'UserRow',
  props: ['userData', 'reviewLists'],
  components: {
    CreateReviewList,
    ConfirmationModal,
    // ApplicantPreview,
  },
  data() {
    return {
      // reviewList: this.reviewLists,
      showCreateReviewListPopup: false,
      showDeleteConfirmationPopup: false,
      showReviewListPopup: false,
      errors: [],
    };
  },
  computed: {
    admin() {
      return this.userData.isAdmin ? 'はい' : 'いいえ';
    },
    notification() {
      return this.userData.notification ? 'On' : 'Off';
    },
  },
  methods: {
    ...mapMutations({
      unsetUser: 'unsetUser',
      unsetReviewList: 'unsetReviewList',
      setPreviewApplicants: 'setPreviewApplicants',
    }),
    ...mapActions({
      loadPreviewList: 'loadPreviewApplicants',
    }),
    showPreviewList(reviewId) {
      window.open(`/preview-applicants/${reviewId}`, '_blank');
    },
    hidePreviewListModal() {
      this.showReviewListPopup = false;
    },
    openDeletePopup() {
      this.$refs.confirmationModal.show();
    },
    closeDeleteModal() {
      this.$refs.confirmationModal.hide();
    },
    editReviewList() {
      this.showCreateReviewListPopup = true;
    },
    hideModal() {
      this.showCreateReviewListPopup = false;
    },
    destroy(reviewList) {
      this.loading = true;
      ApiService.delete(Api.endpoints.DELETE_REVIEW_LIST(this.reviewLists._id)) // eslint-disable-next-line
        .then(() => {
          this.unsetReviewList(this.reviewLists);
          this.loading = false;
        })
        .catch((error) => {
          this.parseErrorResponse(error.response);
          if (this.errors && this.errors.length) {
            this.$emit('error', this.errors[0]);
          }
        });
    },
    async openPreviewList(client_users) {
      try {
        let ids = client_users.map((user) => {
          return user._id;
        });
        let data = {
          client_ids: ids,
        };
        let res = await this.loadPreviewList(data);
        this.setPreviewApplicants(res.data.data);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
td {
  height: 50px;
  font-weight: normal;
  text-align: left;
  border-bottom: 1px solid #787878 !important;
}
.dlt-block {
  text-align: center;
}

.dlt-block i {
  font-size: 30px;
  color: red;
  margin-bottom: 10px;
}
</style>
